import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { login } from "../../context/AuthContext";
import { COURSE_IMAGES } from "../../data/media";

const fadeUp = {
  hidden: { opacity: 0, y: 34 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

export default function Courses({ courses }) {
  return (
    <section id="courses" className="relative py-24 md:py-36 max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
        <div>
          <div className="flex items-center gap-4 mb-6">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-brand-orange">01 / Training</span>
          </div>
          <h2 className="font-heading font-bold uppercase tracking-tighter text-4xl md:text-6xl text-brand-ink leading-[0.9]">
            Choose your<br /><span className="text-brand-brass">line of fire.</span>
          </h2>
        </div>
        <p className="max-w-sm text-brand-muted text-sm leading-relaxed">
          Every course is built on the same foundation — safe handling, real fundamentals,
          and range time that actually sticks. Reserve a slot and pay securely online.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
        {courses.map((c, i) => {
          const wide = i === 0 || i === 3;
          return (
            <motion.div
              key={c.id}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className={`group relative overflow-hidden border border-white/10 bg-brand-surface ${
                wide ? "md:col-span-7" : "md:col-span-5"
              }`}
              data-testid={`course-card-${c.id}`}
            >
              <div className="relative h-64 md:h-72 overflow-hidden">
                <img
                  src={COURSE_IMAGES[c.id]}
                  alt={c.name}
                  className={`w-full h-full object-cover img-treat scale-105 group-hover:scale-100 transition-transform duration-700 ${c.id === "pistol-fundamentals" ? "object-top" : "object-center"}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-surface via-brand-surface/30 to-transparent" />
                <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] bg-brand-bg/70 backdrop-blur px-3 py-1.5 text-brand-brass border border-white/10">
                  {c.level}
                </span>
              </div>

              <div className="p-7 md:p-9">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-heading font-bold uppercase text-2xl md:text-3xl tracking-tight text-brand-ink">
                      {c.name}
                    </h3>
                    <p className="mt-3 text-brand-muted text-sm leading-relaxed max-w-md">{c.tagline}</p>
                  </div>
                </div>

                <div className="mt-8 flex items-center justify-between border-t border-white/10 pt-6">
                  <div className="flex items-baseline gap-4">
                    <span className="font-heading font-black text-3xl text-brand-ink">${c.price.toFixed(0)}</span>
                    <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-brand-muted">{c.duration}</span>
                  </div>
                  <button
                    onClick={login}
                    data-testid={`course-book-${c.id}`}
                    className="group/btn flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-brand-ink hover:text-brand-orange transition-colors"
                  >
                    Book
                    <ArrowUpRight size={15} className="group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform" />
                  </button>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
